import { useMemo } from 'react'
import { deadmanSwitch } from '@/services/index.ts'

export function useContract() {
  return useMemo(() => deadmanSwitch, [])
}
